<template>
  <base-modal
    hide-footer
    :closeable-from-outside="false"
    :size="'lg'"
    :modal-id="'choose-priviege-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Choose Privilege</span>
      </div>
    </template>
    <b-form @submit.prevent="onSaveModalChoosePrivilege">
      <b-row>
        <b-col cols="12" class="px-2">
          <!-- <label class="font-medium-5"
            ><span class="title-select-inventory">Select Inventory</span>
            (ทำการเพิ่มของรางวัลได้ทีละหนึ่งคลัง)</label
          > -->
          <div class="d-flex justify-content-end">
            <!-- <div>
              <div>
                <v-select
                  id="select-inventory"
                  class="v-select-filter bg-dropdown"
                  placeholder="- Select Inventory -"
                />
              </div>
            </div> -->
            <div>
              <div class="d-flex flex-wrap justify-content-end">
                <v-select
                  id="privilege-type-status"
                  class="v-select-filter bg-dropdown"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
                <div
                  class="
                    search-container
                    mb-1 mb-md-0
                    mr-0
                    ml-0 ml-xl-2 ml-lg-1
                  "
                >
                  <search :on-search-input="onSetValueSearch" />
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="px-2 mt-2">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="choosePrivilegeList.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table no-color-head"
              >
                <template #cell(seq)="data">
                  <div class="text-center">
                    {{ data.item.seq }}
                  </div>
                </template>
                <template #head(image_url)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(image_url)="data">
                  <div class="d-flex justify-content-center align-item-center">
                    <img
                      :src="data.item.image_url || DefaultImg"
                      class="middle-image-column"
                    />
                  </div>
                </template>
                <template #cell(name_th)="data">
                  <div class="privilege-name">
                    {{ data.item.name_th }}
                  </div>
                </template>
                <template #cell(privilege_type)="data">
                  <div class="privilege-type">
                    {{ data.item.privilege_type }}
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <div class="privilege-type">
                    {{ resolveDateWithSeperator(data.item.valid_from) }}
                  </div>
                </template>
                <template #cell(valid_through)="data">
                  <div class="privilege-type">
                    {{ resolveDateWithSeperator(data.item.valid_through) }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="mr-2"
                      :class="resolveStatusClass(data.item.status)"
                    />

                    <span>{{ resolveStatusLabel(data.item.status) }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    class="btn-select-image ml-2"
                    @click="selectPrivilege(data.item)"
                    :disabled="data.item.privilege_id == privilege_Id"
                  >
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <span>{{ "Select" }}</span>
                    </div>
                  </b-button>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <div class="d-flex align-item-center flex-column m-auto">
                    <img :src="NoInventory" class="no-inventory-img" />
                    <div class="text-select-inventory">Select Inventory</div>
                  </div>
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12" v-if="choosePrivilegeList.payload.length > 0">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
        <b-col cols="12">
          <div class="mt-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :type="'submit'"
                class="ml-1"
                :disabled="!privilege_Id"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="modal-body-container mb-1" />
    </b-form>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import Search from "@/views/components/search/Search.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useChoosePrivilege from "../hooks/useChoosePrivilege";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import NoInventory from "@/assets/images/artwork/folder.png";

export default {
  components: {
    BaseModal,
    Search,
    AddButton,
    PaginationWithReorder,
    CardNoItem,
  },
  props: { loadingOverlay: Object, privilegeId: { type: Number, default: 0 } },
  setup(props) {
    const {
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      loading,
      statusOption,
      fields,
      choosePrivilegeList,
      resolveStatusLabel,
      resolveStatusClass,

      selectPrivilege,
      privilege_Id,
      onSaveModalChoosePrivilege,

      resolveDateWithSeperator
    } = useChoosePrivilege(props);

    return {
      DefaultImg,
      NoInventory,

      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,

      loading,
      statusOption,
      fields,
      choosePrivilegeList,
      resolveStatusLabel,
      resolveStatusClass,

      selectPrivilege,
      privilege_Id,
      onSaveModalChoosePrivilege,

      resolveDateWithSeperator
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/override-styles/v-select.css";
@import '~@/assets/css/pages/privilege/privilege-code-template/choose-privilege-modal.css';
</style>
